import React, { Component } from "react";
import classNames from "classnames";
import { SubmissionError } from "redux-form";
import { validateEmail } from "ReactComponents/Shared/ReduxFormInputs";
import { newsletterComposer } from "ReactReducers/Newsletter/newsletter-composer";
import NewsletterSignupBannerForm from "./newsletter-signup-banner-form";

class NewsletterSignupBanner extends Component {
    constructor(props) {
        super(props);

        this.validateNewsletterSignupForm = this.validateNewsletterSignupForm.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    validateNewsletterSignupForm(values) {
        const errors = {};

        if (!values.name) {
            errors.name = this.props.InvalidNameMessage;
        }
        if (!values.email) {
            errors.email = this.props.InvalidEmailMessage;
        } else if (!validateEmail(values.email)) {
            errors.email = this.props.InvalidEmailMessage;
        }
        if (!values.permission) {
            errors.permission = this.props.InvalidPermissionMessage || "No message...";
        }
        if (!values.CaptchaResponse) {
            errors.recaptcha = "Recaptcha validation failed";
        }

        const hasNoErrors = Object.keys(errors).length === 0 && errors.constructor === Object;
        return hasNoErrors ? null : errors;
    }

    handleSubmit(userInfo) {
        const userData = Object.assign({}, userInfo);

        const recaptchaResponse = window.grecaptcha.getResponse();
        userData.CaptchaResponse = recaptchaResponse;

        // return promise that is resolves/rejected in saga
        return new Promise((resolve, reject) => {
            const webApiUrl = this.props.WebApiUrl || "/WebAPI/Feature/Profile/SubscribeNewsletter";
            const errors = this.validateNewsletterSignupForm(userData);

            if (errors) {
                throw new SubmissionError(errors);
            } else {
                this.props.newsletterSignup(userData, resolve, reject, webApiUrl);
            }
        }).then(response => {
            if (response.Success) {
                const redirectUrl = this.props.SuccessRedirectLink || "/newsletter/newsletter-settings";
                window.location.pathname = redirectUrl;
            } else {
                // We make an extra validation on the email with NeverBounce in the backend.
                // This will return a false respnse.Success and a specific ErrorMessage to display on the email input
                throw new SubmissionError({ email: response.ErrorMessage });
            }
        });
    }

    render() {
        const backgroundColorClass = this.props.ContentBackgroundColorClass;
        const textColorClass = this.props.ContentTextColorClass;
        const baseClass = "newsletter-banner";
        const rootClasses = classNames(
            baseClass,
            "content-module",
            { [`${backgroundColorClass}--bg`]: backgroundColorClass },
            { [`${textColorClass}--text`]: textColorClass }
        );
        const headerClasses = classNames(`${baseClass}__header`, {
            [`${textColorClass}--text`]: textColorClass
        });

        return (
            <div className={rootClasses}>
                <div className={`${baseClass}__inner content-module__landingpage-inner`}>
                    <div className="content-row">
                        {this.props.TrumpetText && (
                            <p className={`${baseClass}__trumpet`}>{this.props.TrumpetText}</p>
                        )}
                        <div className={`${baseClass}__content-wrapper`}>
                            <p className={headerClasses}>{this.props.TitleText}</p>
                            <div
                                className={`${baseClass}__description`}
                                dangerouslySetInnerHTML={{ __html: this.props.DescriptionText }}
                            />
                        </div>
                        <div className={`${baseClass}__form-wrapper`}>
                            <NewsletterSignupBannerForm {...this.props} onSubmit={this.handleSubmit} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default newsletterComposer(NewsletterSignupBanner);
